<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('promotion.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('promotion.pageTitle'),
          href: '/admin/promotions',
        },
        {
          text: $t('create'),
          active: true,
        },
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <a-tabs :default-active-key="1" @change="callback">
            <a-tab-pane :key="1" :tab="$t('promotion.discount')">
              <DiscountForm v-if="activeTab == 1" />
            </a-tab-pane>
            <a-tab-pane :key="2" :tab="$t('promotion.freeItemPerAmount')">
              <FreeItemPerAmountForm v-if="activeTab == 2" />
            </a-tab-pane>
            <a-tab-pane :key="3" :tab="$t('promotion.freeCoinPerAmount')">
              <FreeCoinPerAmountForm v-if="activeTab == 3" />
            </a-tab-pane>
            <a-tab-pane :key="4" :tab="$t('promotion.buyItemFreeItem')">
              <BuyItemFreeItemForm v-if="activeTab == 4" />
            </a-tab-pane>
            <a-tab-pane :key="5" :tab="$t('promotion.incentiveByItem')">
              <IncentiveByItemForm v-if="activeTab == 5" />
            </a-tab-pane>
            <a-tab-pane :key="6" :tab="$t('promotion.incentiveByAmount')">
              <IncentiveByAmountForm v-if="activeTab == 6" />
            </a-tab-pane>
            <a-tab-pane :key="7" :tab="$t('promotion.discountByRange')">
              <DiscountByRangeForm v-if="activeTab == 7" />
            </a-tab-pane>
            <a-tab-pane :key="8" :tab="$t('promotion.promotionPackage')">
              <PromotionPackageForm v-if="activeTab == 8" />
            </a-tab-pane>
          </a-tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import DiscountForm from './components/discount-form'
import FreeItemPerAmountForm from './components/free-item-per-amount-form'
import FreeCoinPerAmountForm from './components/free-coin-per-amount-form'
import BuyItemFreeItemForm from './components/buy-item-free-item-form'
import IncentiveByItemForm from './components/incentive-by-item-form'
import IncentiveByAmountForm from './components/incentive-by-amount-form'
import DiscountByRangeForm from './components/discount-by-range-form'
import PromotionPackageForm from './components/promotion-package-form'
import { mapActions } from 'vuex'

export default {
  name: 'promotionCreate',
  components: {
    DiscountForm,
    FreeItemPerAmountForm,
    FreeCoinPerAmountForm,
    BuyItemFreeItemForm,
    IncentiveByItemForm,
    IncentiveByAmountForm,
    DiscountByRangeForm,
    PromotionPackageForm
  },
  data() {
    return {
      loading: false,
      activeTab: 1
    }
  },
  methods: {
    ...mapActions('promotion/resource', ['getBranch', 'getSaleCode']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
      await this.getSaleCode()
      this.loading = false
    },
    callback(key) {
      this.activeTab = key
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/resource/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>